/* src/modules/dashboard/components/LineGraph/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  FormControl,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { Update } from '@material-ui/icons';
import { Line } from 'react-chartjs-2';
import { loadTexts } from '../../../../config/texts';

import styles from './styles';

const graphOptions = {
  fill: 'origin',
  lineTension: 0.1,
  backgroundColor: 'rgba(84, 84, 178, 0.4)',
  borderColor: 'rgb(84, 84, 178)',
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBorderColor: 'rgb(84, 84, 178)',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: 'rgb(84, 84, 178)',
  pointHoverBorderColor: 'rgb(220, 220, 220)',
  pointHoverBorderWidth: 2,
  pointRadius: 1,
  pointHitRadius: 10,
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  legend: { position: 'left', labels: { boxWidtH: 10 } },
};

const TEXT_KEY = 'dashboard';

class LineGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTimeFrame: props.currentTimeFrame,
      currentType: props.currentType,
      data: props.data,
      labels: props.labels,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._onChangeStartDate = this._onChangeStartDate.bind(this);
    this._onChangeEndDate = this._onChangeEndDate.bind(this);

    this._onClickUpdate = this._onClickUpdate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentTimeFrame, currentType, data, labels } = nextProps;
    this.setState({ currentTimeFrame, currentType, data, labels });
  }

  _onChangeStartDate(event) {
    this.props.onChangeStartDate(event.target.value);
  }

  _onChangeEndDate(event) {
    this.props.onChangeEndDate(event.target.value);
  }

  _onClickUpdate() {
    this.props.onClickUpdate();
  }

  renderSelect(classes, type, options, currentValue, callback) {
    const id = `option-${type}`;
    return (
      <FormControl className={classes[`formControl-${type}`]}>
        <InputLabel htmlFor={id}>
          {type}
        </InputLabel>
        <Select
          value={currentValue}
          onChange={event => callback(event.target.value)}
          input={<Input name="option" id={id} />}
        >
          {map(options, ({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  render() {
    const {
      title,
      timeFrames,
      types,
      onTimeFrameChange,
      onTypeChange,
      label,
      classes,
      startDate,
      endDate,
    } = this.props;
    const { currentTimeFrame, currentType, data, labels, texts } = this.state;
    const dataset = { ...graphOptions, label, data };
    const datasets = { labels, datasets: [dataset] };
    // console.log('dataaa', data)
    let total = 0;
    map(data, d => {
      total = total + d
    })
    
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography color="primary" variant="title">
            {title}
          </Typography>
          <div className={classes.textFields}>
            <TextField
              className={classes.startDateTextField}
              id="dashboard_start_date"
              label={texts.start_date}
              type="date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={this._onChangeStartDate}
            />
            <TextField
              className={classes.textField}
              id="dashboard_end_date"
              label={texts.end_date}
              type="date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={this._onChangeEndDate}
            />
            <IconButton color="primary" onClick={this._onClickUpdate}>
              <Update />
            </IconButton>
          </div>
          <div>
            {this.renderSelect(classes, 'Time', timeFrames, currentTimeFrame, onTimeFrameChange)}
            {this.renderSelect(classes, 'Type', types, currentType, onTypeChange)}
          </div>
        </div>
        <Line data={datasets} height={120} options={chartOptions} />
        {title == texts.title.number_users && (
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Typography color="textPrimary" variant="display2">
              {total}
            </Typography>
            <Typography color="textPrimary" variant="subheading">
              {texts.title.total_users}
            </Typography>
          </div>
        )}
        {title == texts.title.lesson_analysis && (
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Typography color="textPrimary" variant="display2">
              {total}
            </Typography>
            <Typography color="textPrimary" variant="subheading">
              {texts.title.total_lessons}
            </Typography>
          </div>
        )}
      </div>
    );
  }
}

const optionPropType = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.any,
  label: PropTypes.string,
}));

LineGraph.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.array,
  labels: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  onTimeFrameChange: PropTypes.func,
  onTypeChange: PropTypes.func,
  timeFrames: optionPropType,
  types: optionPropType,
  currentTimeFrame: PropTypes.any,
  currentType: PropTypes.any,
  onChangeStartDate: PropTypes.func.isRequired,
  onChangeEndDate: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onClickUpdate: PropTypes.func,
};

LineGraph.defaultProps = {
  data: [],
  labels: [],
  label: '',
  onTimeFrameChange: () => {},
  onTypeChange: () => {},
  timeFrames: [],
  types: [],
  currentTimeFrame: null,
  currentType: null,
  onClickUpdate: () => {},
};

const mapStateToProps = state => {
  const {
    appState: {
      locale
    }
   } = state;
  return {
    locale,
  };
};


export default compose(
  withStyles(styles, { name: 'LineGraph' }),
  connect(mapStateToProps, {})
)(LineGraph);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/LineGraph/index.js